import firebase from "firebase/compat/app"
import "firebase/compat/auth"
import "firebase/compat/firestore"
import "firebase/compat/analytics"
import "firebase/compat/storage"

import { getStripePayments } from "@stripe/firestore-stripe-payments"

const app = firebase.initializeApp({
  apiKey: "AIzaSyBxab_FNGsrBwhk8WTMa4ntD2ad8zYOnAQ",
  authDomain: "activitydir.firebaseapp.com",
  projectId: "activitydir",
  storageBucket: "activitydir.appspot.com",
  messagingSenderId: "1000526155915",
  appId: "1:1000526155915:web:0100dd5c282603b40c448e",
})

firebase.analytics()

export const auth = app.auth()
export const firestore = app.firestore()
export const firebaseInstance = firebase
export const GoogleAuthProvider = firebase.auth.GoogleAuthProvider
export const storage = firebase.storage()

export default app

export const payments = getStripePayments(app, {
  productsCollection: "products",
  customersCollection: "users",
})

export const serverTimestamp = firebase.firestore.FieldValue.serverTimestamp
